import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { NHOMTIEUCHI_API } from '@app/utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../../utils/define';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    phan: yup.number().required(messageError.emptyMessage).min(1, 'Phần phải lớn hơn 0'),
    diemToiDa: yup.number().required(messageError.emptyMessage).min(0, 'Điểm tối đa không được nhỏ hơn 0'),
    tenNhomTieuChi: yup.string().required(messageError.emptyMessage).max(255, 'Tên nhóm tiêu chí không được vượt quá 255 ký tự')
});

const NhomTieuChiEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = require('react-router-dom').useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const id = paramUrl.get('id');

    const itemQuery = useQuery(['nhomTieuChi', id], () => Get(NHOMTIEUCHI_API.GET_ITEM, id), {
        enabled: !!id
    });

    const editFunc = useMutation((value) =>
        Put(NHOMTIEUCHI_API.UPDATE_ITEM, id, value)
    );

    const handleUpdate = (values) => {
        const model = values;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.setQueryData(['nhomTieuChi', id], values);
                    history.push(URI_INTERNAL.NHOMTIEUCHI_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return <div>Có lỗi xảy ra hoặc không tìm thấy nhóm tiêu chí</div>;
    }

    const currentData = itemQuery.data?.data ? itemQuery.data.data : itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Cập nhật nhóm tiêu chí</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleUpdate(values)}
                    initialValues={{
                        phan: currentData.phan || currentData.Phan || 1,
                        tenNhomTieuChi: currentData.tenNhomTieuChi || currentData.TenNhomTieuChi || '',
                        diemToiDa: currentData.diemToiDa || currentData.DiemToiDa || 0,
                        moTa: currentData.moTa || currentData.MoTa || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Phần',
                                        name: 'phan',
                                        type: 'number',
                                        value: values.phan,
                                        onChange: handleChange,
                                        isInvalid: errors.phan,
                                        error: errors.phan
                                    },
                                    {
                                        label: 'Tên nhóm tiêu chí',
                                        name: 'tenNhomTieuChi',
                                        value: values.tenNhomTieuChi,
                                        onChange: handleChange,
                                        isInvalid: errors.tenNhomTieuChi,
                                        error: errors.tenNhomTieuChi
                                    },
                                    {
                                        label: 'Điểm tối đa',
                                        name: 'diemToiDa',
                                        type: 'number',
                                        value: values.diemToiDa,
                                        onChange: handleChange,
                                        isInvalid: errors.diemToiDa,
                                        error: errors.diemToiDa
                                    },
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary">
                                            Lưu
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.NHOMTIEUCHI_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default NhomTieuChiEdit;
